import { cn } from '@/lib/utils.js';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'h-5 w-5',
  md: 'h-9 w-9',
  lg: 'h-14 w-14',
} as const;

const borderMap = {
  sm: 'border-2',
  md: 'border-[3px]',
  lg: 'border-4',
} as const;

/**
 * Custom gradient spinner — indigo gradient circle.
 */
export function LoadingSpinner({
  message = 'Загрузка...',
  size = 'md',
  className,
}: LoadingSpinnerProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-8', className)}>
      <div className="relative" aria-hidden>
        <div className={cn('rounded-full border-muted', sizeMap[size], borderMap[size])} />
        <div
          className={cn(
            'absolute inset-0 rounded-full border-transparent border-t-primary animate-spin-slow',
            sizeMap[size],
            borderMap[size],
          )}
        />
      </div>
      {message && <p className="text-small text-muted-foreground">{message}</p>}
    </div>
  );
}
